import theme from '@styles/theme/index';
const calculateMarginBottom = (breakpoint: 1 | 2 | 3 | 4, converter: 0.25 | 0.5 | 0.75 | 1 | 1.25 | 1.5): number => {
  const fontSizes = {
    1: theme.fontSizes.h1,
    2: theme.fontSizes.h1,
    3: theme.fontSizes.mediumHeading,
    4: theme.fontSizes.displayFive
  };
  return -8 - fontSizes[breakpoint] / 100 * 110 * converter;
};
const marginsBottom = {
  '0.25': [calculateMarginBottom(1, 0.25), calculateMarginBottom(2, 0.25), calculateMarginBottom(3, 0.25), calculateMarginBottom(4, 0.25)],
  '0.5': [calculateMarginBottom(1, 0.5), calculateMarginBottom(2, 0.5), calculateMarginBottom(3, 0.5), calculateMarginBottom(4, 0.5)],
  '0.75': [calculateMarginBottom(1, 0.75), calculateMarginBottom(2, 0.75), calculateMarginBottom(3, 0.75), calculateMarginBottom(4, 0.75)],
  '1': [calculateMarginBottom(1, 1), calculateMarginBottom(2, 1), calculateMarginBottom(3, 1), calculateMarginBottom(4, 1)],
  '1.25': [calculateMarginBottom(1, 1.25), calculateMarginBottom(2, 1.25), calculateMarginBottom(3, 1.25), calculateMarginBottom(4, 1.25)],
  '1.5': [calculateMarginBottom(1, 1.5), calculateMarginBottom(2, 1.5), calculateMarginBottom(3, 1.5), calculateMarginBottom(4, 1.5)]
};
export default {
  styledSection: (bg?: string) => ({
    height: [190, 190, 203, 263],
    width: '100%',
    position: 'relative',
    bg,
    zIndex: theme.zIndex.documentHigh
  }),
  contentHolder: (bottomPosition: string) => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
    bottom: marginsBottom[bottomPosition]
  }),
  fixedHeader: {
    maxWidth: '100%',
    position: 'sticky',
    top: 0,
    left: 0,
    height: 'auto',
    marginLeft: ['10.6666667vw', '10.6666667vw', '8.33333333vwvw', '10.15625vw'],
    zIndex: theme.zIndex.documentUp
  },
  styledHeading: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  styledMainHeading: {
    fontFamily: theme.fonts.noe,
    fontWeight: theme.fontWeights.bold,
    lineHeight: '110%',
    letterSpacing: theme.letterSpacings.mediumCaps,
    fontSize: [theme.fontSizes.h1, theme.fontSizes.h1, theme.fontSizes.mediumHeading, theme.fontSizes.displayFive],
    textTransform: 'none'
  },
  styledSubtitleHeading: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.h5,
    lineHeight: '140%',
    letterSpacing: theme.letterSpacings.bigCaps,
    textTransform: 'uppercase',
    pb: 24
  }
};